// Navigation.js

import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { AuthProvider, useAuthContext } from "../hooks/Auth";
import ProtectedRoutes from "./ProtectedRoutes";
import PublicRoutes from "./PublicRoutes";
import LoginPage from "../pages/LoginPage";
import LtiApp from "../lti/schoology/app";
import { OASProvider } from "../context/SuperAdmin/OASContexts/OASContext";
import { OrganizationProvider } from "../context/OrganizationContext";

// Componente interno que maneja el routing basado en el estado de autenticación
const NavigationRoutes: React.FC = () => {
  const { isUserAuthenticated } = useAuthContext();
  const { user } = useAuthContext();

  return (
    <OASProvider organizationId={user?.id_organizacion}>
      <Routes>
        {/* Ruta LTI: pública y sin wrappers */}
        <Route path="/lti/app" element={<LtiApp />} />

        {/* Si el usuario está autenticado (incluyendo LTI), redirigir a rutas protegidas */}
        {isUserAuthenticated ? (
          <>
            {/* Ruta privada */}
            <Route path="/asistente/*" element={<ProtectedRoutes />} />
            {/* Redireccionar cualquier otra ruta al menú principal */}
            <Route path="*" element={<Navigate to="/asistente/menu" replace />} />
          </>
        ) : (
          <>
            {/* Ruta pública */}
            <Route
              path="/auth/*"
              element={
                <PublicRoutes>
                  <Routes>
                    <Route path={"login"} element={<LoginPage />}></Route>
                    <Route
                      path="/*"
                      element={<Navigate to="/auth/login" replace />}
                    ></Route>
                  </Routes>
                </PublicRoutes>
              }
            />
            {/* Otras rutas o redireccionar a /login si no se encuentra una ruta */}
            <Route path="*" element={<Navigate to="/auth/login" replace />} />
          </>
        )}
      </Routes>
    </OASProvider>
  );
};

const Navigation: React.FC = () => {
  return (
    <AuthProvider>
      <OrganizationProvider>
        <Router>
          <NavigationRoutes />
        </Router>
      </OrganizationProvider>
    </AuthProvider>
  );
};

export default Navigation;
